<template>
  <div
    class="image-text-card gap-40px md-max:mb-40px sm-max:max-w-sm flex flex-col md:max-w-lg xl:max-w-2xl">
    <div class="px-20px md:px-40px xl:px-60px">
      <img
        class="mx-auto w-48 md:w-64"
        :src="image.url"
        :alt="image.description" />
    </div>
    <div
      class="px-20px md:px-40px xl:px-60px"
      :class="{ 'md:border-l-orange md:border-l-4': showBorder }">
      <!-- <h2 class="text-22 md:text-24 xl:text-30 mb-20px">{{ data.title }}</h2> -->
      <Title class="text-default" :headingTag="'h2'" :style="'h3'">
        {{ data.title }}
      </Title>
      <CardBody
        class="image-text-card__body"
        :textAlignment="'left'"
        :text="data.body">
      </CardBody>
      <!-- <p>
        If you do nothing at enrollment, initial contributions are invested in a
        <strong>Capital Preservation Fund</strong>.
      </p>
      <img
        class="my-20px mx-auto w-12"
        :src="data.twoCol.one.arrow.src"
        :alt="data.twoCol.one.arrow.alt" />
      <p>
        After 30 days, your existing savings and future contributions move to a
        <strong>Target Retirement Date Fund</strong> based on your age.
      </p> -->
    </div>
  </div>
</template>

<script>
import CardBody from "../../Atoms/Cards/CardBody.vue";
import Title from "../../Atoms/Heading.vue";

export default {
  components: {
    CardBody,
    Title,
  },

  props: {
    data: {
      type: Object,
      required: true,
    },
    showBorder: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  setup(props) {
    const image = props.data.hasOwnProperty("image")
      ? props.data.image
      : props.data.icon;

    return {
      image,
    };
  },
};
</script>
